<div >
  <router-outlet></router-outlet>
</div>

<ngx-spinner name="silentSpinner" bdColor="rgba(0, 0, 0, 0)" color="rgba(0, 0, 0, 0)" size="small" [fullScreen]="true">
</ngx-spinner>
